import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";
import { useState } from "react";
import { LeadModal } from "./LeadModal";

export const PageShell = ({ children }) => {
  const [consultOpen, setConsultOpen] = useState(false);
  return (
    <div className="App min-h-screen bg-[#0a1128]" data-testid="page-shell">
      <Navbar onOpenConsult={() => setConsultOpen(true)} />
      <main>{children}</main>
      <Footer />
      <CookieBanner />
      <LeadModal
        open={consultOpen}
        onClose={() => setConsultOpen(false)}
        projectName="Universal Dream Properties"
        accentColor="#C5A059"
        unitLabel="Property type of interest"
        unitOptions={[
          "Off-plan apartment",
          "Off-plan villa / townhouse",
          "Ready apartment",
          "Ready villa / townhouse",
          "Commercial / retail",
          "Not sure yet — please advise",
        ]}
        headline={
          <>
            Book your private
            <br />
            <em className="italic" style={{ color: "#C5A059" }}>consultation</em>
          </>
        }
      />
    </div>
  );
};
